import _extends from "@babel/runtime/helpers/extends";

/*
 * @Author: wangshengqiang
 * @Date: 2021-04-21 13:57:27
 * @LastEditTime: 2022-03-07 15:27:56
 * @LastEditors: wangshengqiang
 * @Description: 证件号录入组件
 */
import React, { useEffect } from 'react';
import { useStore } from '@/store';
import { getPreLeveFormKey } from '@/utils/utils.js';
import { certNoLengthMap } from '@/validator';
import { validateIdCard } from '@/validator/proValidator.js';
import RowInput from '../RowInput';
import './index.less';
export default function CertNo(props) {
  const {
    validateFields
  } = props.form;
  const formKeyPrefix = getPreLeveFormKey(props.formKey);
  const certType = useStore(`formValues.${formKeyPrefix}.certType`); // 验证

  const rules = [{
    validator: (rule, value, callback) => {
      validateIdCard(rule, value, callback, certType);
    }
  }]; // 证件号最大长度

  const maxLength = certNoLengthMap[certType];
  useEffect(() => {
    validateFields([props.formKey]);
  }, [certType]);
  return /*#__PURE__*/React.createElement(RowInput, _extends({}, props, {
    rules: rules,
    maxLength: maxLength
  }));
}